<template>
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label class="form-control-label">Produto</label>
          <el-tooltip content="Produtos serão apresentados baseados no estoque da empresa selecionada." placement="top">
            <i class="fas fa-info-circle fa-sm text-grey ml-2" style="cursor: pointer;"></i>
          </el-tooltip>
        <base-input :required="true">
          <multiselect
            v-model="orderItem.product"
            :options="stocks"
            placeholder="Selecionar Produto"
            label="desc_psv"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            track-by="codi_psv"
            :loading="isLoadingProduct"
            @search-change="debouncedInitStocks"
            :internal-search="false"
            @input="
              orderItem.product_code = orderItem.product.codi_psv;
              updateCostsbyunitaryValue(orderItem)
              $emit('update:order-item', orderItem);
              resetCulture();
              initCultures(orderItem.product.codi_psv);
              validateClientCategoryGroup(orderItem.product);
              validateFields();
            "
            :key="orderItem.product ? orderItem.product.codi_psv : orderItem.product"
          >
            <template v-slot:noResult> Nenhum Resultado Encontrado </template>
            <template slot="option" slot-scope="props">
              <div class="option__desc"><span class="option__title">{{ props.option.codi_psv }} - {{ props.option.desc_psv }}</span></div>
            </template>
            <template slot="singleLabel" slot-scope="props">
              <span class="multiselect__single">{{ props.option.codi_psv }} - {{ props.option.desc_psv }}</span>
            </template>
          </multiselect>
          <div
            v-if="!validClientCategoryGroup"
            class="invalid-feedback"
            style="display: block;"
          >
            Cliente sem autorização de compra de defensivos!
          </div>
          <div
            v-if="!validField(orderItem.product)"
            class="invalid-feedback"
            style="display: block;"
          >
            Campo Obrigatório
          </div>
        </base-input>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <label class="form-control-label">Cultura</label>
        <base-input :required="true">
          <multiselect
            :key="orderItem.culture ? orderItem.culture.codi_cul : orderItem.culture"
            v-model="orderItem.culture"
            :options="cultures"
            placeholder="Selecionar Cultura"
            label="nome_cul"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            track-by="codi_cul"
            :searchable="true"
            :loading="loadingCultures"
            :internal-search="false"
            :close-on-select="true"
            :options-limit="300"
            :show-no-results="true"
            @search-change="debouncedSearchCultures"
            @input="$nextTick(() => $forceUpdate())"
          >
            <template v-slot:noResult> Nenhum Resultado Encontrado </template>
          </multiselect>
          <div
            v-if="cultureMandatory && (
              !orderItem.culture || 
              (typeof(orderItem.culture) == 'object' && Object.keys(orderItem.culture).length == 0))
            "
            class="invalid-feedback"
            style="display: block;"
          >
            Campo Obrigatório
          </div>
        </base-input>
      </div>
    </div>
    <div class="col-md-6">
      <base-input
        :value="orderItem.product ? orderItem.product.fisico : 0"
        placeholder="10"
        label="Estoque Fisíco"
        disabled
        @input="$emit('update:order-item', orderItem)"
      />
    </div>
    <div class="col-md-6">
      <base-input
        :value="orderItem.product ? orderItem.product.disponivel : 0"
        placeholder="10"
        label="Estoque Disponível"
        disabled
        @input="$emit('update:order-item', orderItem)"
      />
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <label class="form-control-label">Tabela</label>
        <multiselect
          v-model="orderItem.price_table"
          :options="filteredPriceTables"
          placeholder="Selecionar Tabela"
          :select-label="''"
          :deselect-label="''"
          :selected-label="'Selecionado'"
          :required="true"
          label="description"
          track-by="id"
          :loading="isLoadingTable"
          @input="
            updateCostsbyunitaryValue(orderItem)
            $emit('update:order-item', orderItem);
            validateSalesmanPriceTable(orderItem.price_table)
            validateUserPriceTable(orderItem.price_table)
            validateConditionPriceTableUsage(orderItem.price_table)
            validateFields();
          "
          :key="orderItem.price_table ? orderItem.price_table.id : orderItem.price_table"
        >
          <template slot="option" slot-scope="props">
            <div class="option__desc"><span class="option__title">{{ props.option.code }} - {{ props.option.description }}</span></div>
          </template>
          <template slot="singleLabel" slot-scope="props">
            <span class="multiselect__single">{{ props.option.code }} - {{ props.option.description }}</span>
          </template>
        </multiselect>
        <div
          v-if="!validField(orderItem.price_table)"
          class="invalid-feedback"
          style="display: block;"
        >
          Campo obrigatório
        </div>
        <div
          v-if="!validSalesmanPriceTable"
          class="invalid-feedback"
          style="display: block;"
        >
          Vendedor sem autorização de uso da tabela
        </div>
        <div
          v-if="!validUserPriceTable"
          class="invalid-feedback"
          style="display: block;"
        >
          Usuário logado sem autorização de uso da tabela
        </div>
        <div
          v-if="!validClientCategoryPriceTable"
          class="invalid-feedback"
          style="display: block;"
        >
          Cliente sem autorização de uso da tabela de preço
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <base-input
        v-model="orderItem.quantity"
        placeholder="Quantidade KG/L"
        label="Quantidade"
        :required="true"
        type="number"
        :min="0"
        @input="computeCosts(orderItem); $emit('update:order-item', orderItem); validateFields();"
      >
        <template v-slot:error>
          <div
            v-if="!validField(orderItem.quantity)"
            class="invalid-feedback"
            style="display: block;"
          >
            Campo obrigatório
          </div>
        </template>
      </base-input>
    </div>
    <div class="col-md-6">
      <base-input
        v-model="orderItem.unit_value"
        placeholder="Valor Unitário do Produto"
        label="Valor Unitário"
        :required="true"
        mask="money"
        @input="computeCosts(orderItem); $emit('update:order-item', orderItem); validateFields();"
      >
        <template v-slot:error>
          <div
            v-if="!validField(orderItem.unit_value)"
            class="invalid-feedback"
            style="display: block;"
          >
            Campo obrigatório
          </div>
        </template>
      </base-input>
    </div>
    <div class="col-md-6">
      <base-input
        v-model="orderItem.discount_percentage"
        placeholder="Desconto"
        :required="true"
        type="integer"
        append-icon="fa fa-percent"
        @input="computeCosts(orderItem); $emit('update:order-item', orderItem);"
        label="Desconto Comercial"
      >
      </base-input>
    </div>
    <div class="col-md-6">
      <base-input
        :value="orderItem.max_discount || 0"
        placeholder="Desconto Máximo do Produto"
        append-icon="fa fa-percent"
        label="Desconto Máximo do Produto"
        disabled
        @input="$emit('update:order-item', orderItem)"
      >
      </base-input>
    </div>
    <div class="col-md-6">
      <base-input
        :value="orderItem.minimum_price || 0"
        mask="money"
        placeholder="Valor Mínimo"
        label="Valor Mínimo"
        disabled
      >
      </base-input>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label class="form-control-label">Campanha</label>
        <multiselect
          v-model="orderItem.campaign"
          :options="campaigns"
          placeholder="Selecionar Campanha"
          label="name"
          :select-label="''"
          :deselect-label="''"
          :selected-label="'Selecionado'"
          track-by="id"
          @input="
            computeCosts(orderItem);
            $emit('update:order-item', orderItem);
          "
        />
      </div>
    </div>
    <div class="col-md-6">
      <label class="form-control-label">Previsão de Entrega</label>
      <base-input
        addon-left-icon="ni ni-calendar-grid-58"
      >
        <flat-picker
          slot-scope="{ focus, blur }"
          @on-open="focus"
          @on-close="blur"
          :config="{
            allowInput: true,
            locale: 'pt',
            altInput: true,
            altFormat: 'd/m/Y',
            minDate: 'today',
          }"
          class="form-control datepicker"
          v-model="orderItem.delivery_date"
          @on-change="computeCosts(orderItem); $emit('update:order-item', orderItem); validateFields();"
          placeholder="Data de Entrega"
          :required="true"
        />
        <template v-slot:error>
          <div
            v-if="!validField(orderItem.delivery_date)"
            class="invalid-feedback"
            style="display: block;"
          >
            Campo obrigatório
          </div>
        </template>
      </base-input>
    </div>
    <div class="col-md-6">
      <base-input
        :value="orderItem.total_cost || 0"
        mask="money"
        placeholder="Total do Item"
        label="Total do Item"
        disabled
      >
    </base-input>
    </div>
  </div>
</template>
<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import swal from "sweetalert2";

export default {
  name: "order-item-form",
  components: {
    flatPicker,
    Multiselect,
  },
  data: () => ({
    cultures: [],
    cultureMandatory: false,
    products: [],
    isLoadingProduct: false,
    stockTimeout: null,
    stocks: [],
    validSalesmanPriceTable: true,
    validUserPriceTable: true,
    validClientCategoryPriceTable: true,
    productsTimeout: null,
    culturesTimeout: null,
    priceTables: [],
    isLoadingTable: false,
    loadingCultures: false
  }),
  props: {
    valid: {
      type: Boolean,
      default: true,
      description: "Tells if the order item have validation errors"
    },
    purchaseOrder: {
      type: Object,
      required: true
    },
    orderItem: {
      type: Object,
      required: true
    },
    discount: {
      type: Number,
      required: true
    },
    orderDiscount: {
      type: Number,
      required: true
    },
    validClientCategoryGroup: {
      type: Boolean,
      default: true,
    },
    validFields: {
      type: Boolean,
      default: false,
    },
    campaigns: Array,
    isLoading: Boolean,
    productValidationData: Object,
    
  },
  mounted() {
    this.initStocks()
    this.validateFields()
    this.setPriceTables()
  },
  methods: {
    async setPriceTables() {
      this.isLoadingTable = true;
      try {
        const response = this.$http.secured.get("/api/v1/price_tables");
        this.priceTables = response.data.sort((a, b) => (a.code > b.code) ? 1 : -1);
      } catch (error) {
        console.error(error, "[OrdemItemForm][setPriceTables], Something went wrong");
      } finally {
        this.isLoadingTable = false;
      }
    },
    resetCulture() {
      this.orderItem.culture = null
    },
    debouncedInitStocks(query = null){
      if(this.productsTimeout) clearTimeout(this.productsTimeout);

      this.productsTimeout = setTimeout(() => this.initStocks(query), 500)
    },
    debouncedSearchCultures(query = null){
      if(this.culturesTimeout) clearTimeout(this.culturesTimeout);

      this.culturesTimeout = setTimeout(() => this.searchCultures(query), 500)
    },
    async initStocks(query = null) {
      this.isLoadingProduct = true
      let queryObj = query ? { desc_psv: query } : null

      try {
        const response = await this.$http.secured.get("/api/v1/report/stocks_data", {
          params: {
            codi_emp: this.purchaseOrder.enterprises
              ? this.purchaseOrder.enterprises.codi_emp
              : null,
            codi_psv: this.codi_psv ? this.codi_psv : null,
            desc_psv: queryObj ? queryObj.desc_psv : null
          },
        })
        this.stocks = response.data.stocks || [];
      } catch (error) {
        console.error(error, "[OrdemItemForm][initStocks], Something went wrong");
      } finally {
        this.isLoadingProduct = false;
      }
    },
    async initCultures(codi_psv = null) {
      this.loadingCultures = true; 
      try {
        const response = await this.$http.secured.get("/api/v1/report/cultures_data", {
          params: { codi_psv: codi_psv }
        })
        this.cultures = response.data.prod_cultures
        this.cultures = this.cultures.sort((a, b) => a.codi_cul - b.codi_cul);
        this.cultureMandatory = this.cultures.length && this.cultures[0].ccul_pro === true ? true : false;
      } catch (error) {
        console.error(error, "[OrdemItemForm][initCultures],Something went wrong");
      } finally {
        this.loadingCultures = false; 
      }
    },
    searchCultures(nome_cul = null) {
      this.$http.secured.get("/api/v1/report/cultures_data", {params: { name_and_code: nome_cul, codi_psv: this.orderItem.product ? this.orderItem.product.codi_psv : null}})
      .then((response) => this.cultures = response.data.prod_cultures)
      .catch((error) => console.error(error, "Something went wrong"))
    },
    async updateCostsbyunitaryValue(orderItem) {
      await this.updateUnitaryValue()
      this.computeCosts(orderItem)
    },
    async updateUnitaryValue() {
      if(!this.orderItem.price_table) return;

      this.orderItem.unit_value   = 0;
      this.orderItem.max_discount = 0;

      const selectedProductPrice = await this.getProductPrice(
        this.orderItem.product_code, this.orderItem.price_table.id
      );

      if (!selectedProductPrice) return;

      if (selectedProductPrice.base_value) {
        const parsedBaseValue = this.isPositiveInteger(selectedProductPrice.base_value) ?
          selectedProductPrice.base_value.toFixed(2) :
          selectedProductPrice.base_value;

        this.$set(this.orderItem, 'unit_value', parsedBaseValue);
      }
      this.orderItem.max_discount = selectedProductPrice.discount;
    },
    async getProductPrice(productCode, priceTableId) {
      const params     = { q: { product_code: productCode, price_table_id: priceTableId } }

      const response = await this.$http.secured.get("/api/v1/product_prices", { params: params })
    
      return response.data.product_prices[0]
    },
    computeCosts () {
      this.orderItem.discount            = parseFloat(this.orderItem.discount) || 0
      this.orderItem.discount_percentage = parseFloat(this.orderItem.discount_percentage) || 0
      this.orderItem.total_cost          = parseFloat(this.orderItem.unit_value) * this.orderItem.quantity

      if (this.orderItem.discount < 0) this.orderItem.discount = 0
      if (this.discount < 0)            this.discount = 0

      this.orderItem.minimum_price = this.orderItem.total_cost - (this.orderItem.total_cost * (this.orderItem.discount / 100))
      this.orderItem.total_cost    = this.orderItem.total_cost - (this.orderItem.total_cost * (this.discount / 100))

      this.$emit('update:discount', this.orderItem.discount_percentage)
      this.$emit('update:orderDiscount', this.orderItem.discount)

      this.$nextTick(() => this.$forceUpdate())
    },
    validField(value) {
      if (typeof value != "object")  return !!value;
      if (!value) return false;
      if (value instanceof(Date)) return true;
      if (Object.keys(value).length == 0) return false;

      return true;
    },
    validateFields() {
      let validableData = {
        product: this.orderItem.product, deliveryDate: this.orderItem.delivery_date, 
        priceTable: this.orderItem.price_table, unityValue: this.orderItem.unit_value, quantity: this.orderItem.quantity,
        validSalesmanPriceTable: this.validSalesmanPriceTable, validUserPriceTable: this.validUserPriceTable, 
        validClientCategoryPriceTable: this.validClientCategoryPriceTable
      }

      console.log("validableData: ", validableData)

      let isValid = true;
      for (const validableDataKey in validableData) {
        if (!this.validField(validableData[validableDataKey])) {
          isValid = false;
          break;
        }
      }

      console.log("isValid: ", isValid)

      this.$emit('update:validFields', isValid);
    },
    validateConditionPriceTableUsage(price_table) {
      let conditions = this.productValidationData.condition_validation_data.filter((row) => this.purchaseOrder.payment_type.code == row['condicao'])

      if(conditions.length == 0) return;
      if(conditions.map((row) => parseInt(row['tabela'])).includes(parseInt(price_table.code))) return;

      swal.fire({
        title: 'Liberação Financeira',
        text: "Condição de pagamento precisará de liberação financeira no ERP!",
        confirmButtonColor: '#2dce89',
        confirmButtonText: 'ok'
      })
    },
    validateSalesmanPriceTable(price_table) {
      if(!price_table) return;

      let salesmanCategories = this.productValidationData.salesman_validation_data.filter((row) => this.purchaseOrder.user.id == row['vendedor'])

      if(salesmanCategories.length == 0) {
        this.validSalesmanPriceTable = true
        return
      }

      this.validSalesmanPriceTable = salesmanCategories.map((row) => parseInt(row['tabela'])).includes(parseInt(price_table.code))
    },
    validateUserPriceTable(price_table) {
      if(!price_table) return;

      let userCategories = this.productValidationData.user_validation_data.filter((row) => this.$currentUser().id == row['usuario'])

      if(userCategories.length == 0) {
        this.validUserPriceTable = true
        return
      }

      this.validUserPriceTable = userCategories.map((row) => parseInt(row['tabela'])).includes(parseInt(price_table.code))
    },
    isPositiveInteger(n) {
      return n >>> 0 === parseFloat(n);
    },
    validateClientCategoryPriceTable(price_table) {
      if(!price_table) return;

      const clientCategories = this.productValidationData.client_category_validation_data.filter((row) => this.purchaseOrder.client.category == row['categoria'])

      if (clientCategories.length == 0) {
        this.validClientCategoryPriceTable = true
        return
      }                                                                                                 
      
      this.validClientCategoryPriceTable = clientCategories.map((row) => parseInt(row['tabela'])).includes(parseInt(price_table.code))
    },
    validateClientCategoryGroup(product) {
      this.validClientCategoryGroupHandle = true;

      if (this.purchaseOrder.client.category != 5) return;
      if (product.codi_gpr != 1) return;

      this.validClientCategoryGroupHandle = false;
    },
    
  },
  computed: {
    permittedPriceTables() {
      if (Object.keys(this.purchaseOrder.enterprises).length == 0) return null;
      
      return this.productValidationData.store_validation_data.filter((row) => this.purchaseOrder.enterprises.codi_emp == row['empresa'])
                                                             .map((row) => row['tabela'])
    },
    filteredPriceTables () {
      if (!this.orderItem.product) return this.priceTables

      let tabe_ctas = []

      if (this.orderItem.product.tabe_ctas && this.orderItem.product.tabe_ctas.length) {
        tabe_ctas = this.orderItem.product.tabe_ctas
      } else if (this.stocks.find(product => product.codi_psv == this.orderItem.product.codi_psv)) {
        tabe_ctas = this.stocks.find(product => product.codi_psv == this.orderItem.product.codi_psv).tabe_ctas
      }
      
      if (tabe_ctas.length == 0) return [];
            
      let result = this.priceTables

      if (this.permittedPriceTables) {
        result = result.filter((price_table) => {
          return this.permittedPriceTables.includes(price_table.code)
        })
      }

      result = result.filter((price_table) => {
        return tabe_ctas.includes(price_table.code)
      })

      const clientCategories = this.productValidationData.client_category_validation_data.filter((row) => this.purchaseOrder.client.category == row['categoria'])

      if (clientCategories.length == 0) return result;

      result = result.map((price_table) => {
        const permittedPriceTable = clientCategories.some((category) => category.tabela == price_table.code)

        return permittedPriceTable ? price_table : { $isDisabled: true, ...price_table }
      })

      return result
    },
    validClientCategoryGroupHandle: {
      set(value) {
        this.$emit('update:validClientCategoryGroup', value);
      },
      get() {
        return this.validClientCategoryGroup;
      },
    },
  },
  watch:{
    'purchaseOrder.client': {
      handler: function (newVal){
        if (!newVal) return;

        this.validateClientCategoryGroup(this.orderItem.product)
      },
    },
 }
};
</script>